// 请求接入风控，人机识别，在 url 中拼接一个签名
import { sign } from '@byted/acrawler'
import tool from 'Src/util/tool'
import qs from 'qs'

const host = window.location.host
const httpMethodValid = ['GET', 'POST']
const contentTypeHandled = ['application/json', 'application/x-www-form-urlencoded']

export function addSignature (settings) {
  let url = settings.url || ''
  let requestMethod = (settings.type || '').toUpperCase()
  let contentType = settings.contentType || ''
  let isPost = requestMethod === 'POST'
  let parsedUrl = tool.parseUrl(url)

  if (parsedUrl.host !== host ||
    httpMethodValid.indexOf(requestMethod) <= -1 ||
    (isPost && contentTypeHandled.every(k => contentType.indexOf(k) <= -1))
  ) {
    return url
  }

  let nonce = {
    url: parsedUrl.href
  }
  if (isPost) {
    const isFormData = contentType.indexOf('application/x-www-form-urlencoded') > -1
    nonce.bodyVal2str = isFormData
    nonce.body = {}
    if (isFormData) {
      nonce.body = qs.parse(settings.data || '')
    } else {
      let body = settings.data || '{}'
      try {
        nonce.body = JSON.parse(body)
      } catch (e) {
      }
    }
  }

  const signature = sign(nonce)
  const str = `${url.indexOf('?') > -1 ? '&' : '?'}_signature=${signature}`
  return url + str
}
